import React, { useState, useEffect } from 'react';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import FormLabel from '@mui/material/FormLabel';
import TextField from '@mui/material/TextField';
import { useApi } from '../../../../../hooks/useApi';
import { useCompanyDispatch, useCompanyState } from '../../../../../stateProviders/CompanyStateProvider';
import { ActionButtons } from '../../../../../globalComponents/modal/ActionButtons';
import { Modal } from '../../../../../globalComponents/modal/Modal';
import { LogisticCostsPermit } from '../../../../../types/api/LogisticCosts';

export const EditPermitModal: React.FC<{
    rowData: LogisticCostsPermit;
    gridRef: React.MutableRefObject<any>;
    modalOpen: boolean;
    setModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
}> = ({ rowData, gridRef, modalOpen, setModalOpen }) => {
    const api = useApi();
    const companyState = useCompanyState();
    const companyDispatch = useCompanyDispatch();
    const [permit, setPermit] = useState({
        permitName: '',
        permitDescription: '',
        permitAmount: '',
    });

    useEffect(() => {
        setPermit({
            permitName: rowData.permitName || '',
            permitDescription: rowData.permitDescription || '',
            permitAmount: String(rowData.permitAmount || ''),
        });
    }, [rowData]);
    return (
        <Modal
            open={modalOpen}
            onClose={() => setModalOpen(false)}
            modalTitle={
                <Typography variant="h2" fontWeight="bold">
                    Edit Permit
                </Typography>
            }
            modalBody={
                <Stack spacing={2} sx={{ mb: 2 }}>
                    {[{
                        label: 'Permit Name',
                        name: 'permitName',
                        placeholder: 'Example: Admin Fees',
                        type: 'text',
                        required: true,
                        value: permit.permitName,
                    }, {
                        label: 'Permit Amount ($)',
                        name: 'permitAmount',
                        placeholder: '',
                        type: 'number',
                        required: true,
                        value: permit.permitAmount,
                    }, {
                        label: 'Permit Description',
                        name: 'permitDescription',
                        placeholder: 'Example: Estimated misc admin fees',
                        type: 'text',
                        required: false,
                        value: permit.permitDescription,
                    }].map((field) => (
                        <Stack key={field.name}>
                            <FormLabel component="legend" sx={{ mb: 1 }} required={field.required}>
                                {field.label}
                            </FormLabel>
                            <TextField
                                fullWidth
                                name={field.name}
                                type={field.type}
                                placeholder={field.placeholder}
                                value={field.value}
                                onChange={(e) => {
                                    setPermit({
                                        ...permit,
                                        [field.name]: e.target.value,
                                    });
                                }}
                            />
                        </Stack>
                    ))}
                </Stack>
            }
            modalFooter={
                <ActionButtons
                    confirmButtonText="Edit"
                    confirmCallback={async () => {
                        if(!companyState.logisticCosts?._id) return
                        await api.logisticCosts.editPermit(companyState.logisticCosts._id, {
                            permitName: permit.permitName.trim(),
                            permitAmount: Number(permit.permitAmount) || 0,
                            permitDescription: permit.permitDescription.trim(),
                            _id: rowData._id
                        });
                        const logisticCosts = await api.logisticCosts.find({_id:companyState.logisticCosts._id})
                        companyDispatch({logisticCosts})
                        gridRef.current?.onRefresh();
                        setModalOpen(false);
                    }}
                    confirmDisabled={
                        permit.permitName.trim() === '' ||
                        permit.permitAmount === '' ||
                        Number(permit.permitAmount) <= 0 ||
                        isNaN(Number(permit.permitAmount))
                    }
                    confirmButtonStyle="success"
                    cancelCallback={() => setModalOpen(false)}
                />
            }
        />
    );
}